import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import styled__default from 'styled-components';
import React from 'react';

var _templateObject;
var StyledListItem = styled__default('li')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  align-items: center;\n  border-right: 1px solid \n  display: inline;\n  margin-top: 0;\n  padding: 0 0.625rem 0 0;\n  margin: 0 0 0 0.625rem;\n  white-space: nowrap;\n  & a {\n    color: white;\n    font-size: 0.875rem;\n  }\n  &:last-child {\n    border-right: none;\n  }\n"])));
function FooterLink(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(StyledListItem, {
    role: 'listitem'
  }, children);
}

export default FooterLink;
